module.exports = __webpack_public_path__ + "img/stock7.83c98a9f.png";